
import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { filter, forkJoin, Observable } from 'rxjs';
import { PowerbiPageComponent } from 'src/app/powerbi-page/powerbi-page.component';
import { PowerbiComponent } from 'src/app/powerbi/powerbi.component';
import { PsmPatternDetailsComponent } from 'src/app/bottom-area/service-history-details/psm-details/psm-pattern-details/psm-pattern-details.component'
import { DataService } from 'src/core/services/data.service';
import { ModalService } from 'src/core/services/modal.service';
import { PowerbiService } from 'src/core/services/powerbi.service';
import { SelectedsystemService } from 'src/core/services/selectedsystem.service';
import { environment } from 'src/environments/environment';
import { LoadingService } from 'src/core/services/loading.service';
import { DeviceService } from 'src/core/services/device.service';
import { VisualOrderPipe } from 'src/core/pipes/visual-order.pipe';
import { SelectedContentService } from 'src/core/services/selectedcontent.service';
import { SelectedSystem } from 'src/core/types/selectedSystem.types';

@Component({
  selector: 'app-psm',
  imports: [FormsModule, PsmPatternDetailsComponent, PowerbiComponent, VisualOrderPipe, TranslocoModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './psm.component.html',
  styleUrl: './psm.component.css'
})
export class PsmComponent {
  token: string;
  visuals?: any;
  report: any;
  filters: any[];

  pattern: any;
  isPSMLoading?: boolean;
  isPSMError: boolean;
  screenWidth: number;
  constructor(private modalService: ModalService, private powerbiService: PowerbiService, private http: HttpClient, private dataService: DataService, private selectedSystemService: SelectedsystemService, private loadingService: LoadingService, private deviceService: DeviceService, private selectedContentService: SelectedContentService) { }


  ngOnInit(): void {

    this.loadingService.$isPSMLoading.subscribe((loading) => {
      this.isPSMLoading = loading;
    });
    this.loadingService.$isPSMError.subscribe((error) => {
      this.isPSMError = error;
    });
    this.powerbiService.getspToken().subscribe((response) => {
      this.token = response.accessToken;

      this.selectedSystemService.$selectedPattern.subscribe(x => {
        this.pattern = x;
      })


      this.requestDataFromPowerbi().subscribe((data: any) => {
        const reportDatabase = [];

        data[0].value.forEach(function (arrayItem) {
          if (arrayItem.name.match(/(?!PSM Pattern)\d{1,6}/)) {
            let item = {
              key: arrayItem.name
                .match(/(?!PSM Pattern)\d{1,6}/)
                .toString(),
              id: arrayItem.id,
            };
            reportDatabase.push(item);
          }
        });

        const filtered = reportDatabase.filter(
          (item) => item.key === this.pattern + ""
        );

        const selectedReport = filtered.length > 0 ? filtered[0].id : undefined;


        this.loadingService.$isPSMLoading.next(true);
        this.requestPowerbiInput(selectedReport).subscribe({
          next: (results) => {
            this.loadingService.$isPSMLoading.next(false);
            this.visuals = !results ? [] :
              results[1].resources.filter(
                (item) =>
                  item.type === "lineChart" ||
                  item.type === "barChart" ||
                  item.type === "columnChart" ||
                  item.type === "clusteredColumnChart" ||
                  (item.type === "tableEx" && item.layout.y > 200)
              );

            this.report = { id: selectedReport, groupId: environment.powerbiworkspace, ...results[0]["value"][0] };

            this.token = results[2][0]["accessToken"]

            let serial;
            this.selectedContentService.selectedSystem$.pipe(
              filter((s): s is SelectedSystem => !!s)
            ).subscribe(system => {
              serial = system.SerialNumber;
            });
            this.selectedSystemService.$selectedSubsystem.subscribe(x => {
              console.log("Selected subsystem:", x);
            });
            this.selectedSystemService.$selectedPattern.subscribe(x => {
              this.pattern = x;
            });
            this.filters = [
              {
                $schema: "https://powerbi.com/product/schema#basic",
                target: {
                  table: "Alarms",
                  column: "ALARM_ID",
                },
                operator: "In",
                values: [this.pattern],
              },
              {
                $schema: "https://powerbi.com/product/schema#basic",
                target: {
                  table: "Data",
                  column: "SERIAL_NUMBER",
                },
                operator: "In",
                values: [serial],
              },
            ]
          },
          error: (err) => {
            this.loadingService.$isPSMLoading.next(false);
            this.loadingService.$isPSMError.next(true);
            console.error("Error fetching Power BI input:", err);
          }
        });

      });
    });

  }

  getVisualSize = (visuals) => {
    this.deviceService.screenDimensions$.subscribe(dimensions => {
      this.screenWidth = dimensions.width
    })
    if (this.screenWidth < 768) {
      return 12
    }
    else {
      if (visuals.length > 1) { return 6 }

      else { return 12 }
    }
  }

  requestDataFromPowerbi(): Observable<any[]> {
    const allPatternsRequest$ = this.http.get<any>(`https://api.powerbi.com/v1.0/myorg/groups/${environment.powerbiworkspace}/reports`, { headers: { 'Authorization': `Bearer ${this.token}` } });

    return forkJoin([allPatternsRequest$]);
  }

  requestPowerbiInput(selectedReport): Observable<any[]> {
    const reportRequest$ = this.http.get<any>(`https://api.powerbi.com/v1.0/myorg/groups/${environment.powerbiworkspace}/reports/` + selectedReport + "/pages", { headers: { 'Authorization': `Bearer ${this.token}` } });
    const visualsRequest$ = this.http.put<any>(window.location.protocol + "//" + window.location.hostname + (window.location.port !== "" ? ":" + "8080" : "") + "/data/getvisuals", { report: selectedReport });
    const tokenRequest$ = this.powerbiService.getEmbedToken({ reportId: selectedReport, groupId: environment.powerbiworkspace });

    return forkJoin([reportRequest$, visualsRequest$, tokenRequest$])
  }
}

